const Datamap = [
  {
    "Region": "Central",
    "Store": "34461",
    "Brand": "7-Eleven",
    "Address": "105 West 1st Avenue",
    "City": "Coal Valley",
    "State": "IL",
    "ZipCode": "61240",
    "Division": "Upper Midwest Plains"
  },
  {
    "Region": "Central",
    "Store": "34468",
    "Brand": "7-Eleven",
    "Address": "3017 Kennedy Drive",
    "City": "East Moline",
    "State": "IL",
    "ZipCode": "61244",
    "Division": "Upper Midwest Plains"
  },
  {
    "Region": "Central",
    "Store": "27379",
    "Brand": "7-Eleven",
    "Address": "8250 Watson Rd",
    "City": "St Louis",
    "State": "MO",
    "ZipCode": "63119",
    "Division": "Gateway Midwest"
  },
  {
    "Region": "Central",
    "Store": "26911",
    "Brand": "7-Eleven",
    "Address": "7901 Mexico Rd",
    "City": "St Peters",
    "State": "MO",
    "ZipCode": "63376",
    "Division": "Gateway Midwest"
  },
  {
    "Region": "Central",
    "Store": "18711",
    "Brand": "7-Eleven",
    "Address": "2636 Van Brunt Boulevard",
    "City": "Kansas City",
    "State": "MO",
    "ZipCode": "64127",
    "Division": "Heartland Metro"
  },
  {
    "Region": "Central",
    "Store": "25367",
    "Brand": "7-Eleven",
    "Address": "705 E 3RD Ave",
    "City": "Salt Lake City",
    "State": "UT",
    "ZipCode": "84103",
    "Division": "Mountain West Urban"
  },
  {
    "Region": "Central",
    "Store": "33052",
    "Brand": "7-Eleven",
    "Address": "1595 West 47th Avenue",
    "City": "Denver",
    "State": "CO",
    "ZipCode": "80211",
    "Division": "Front Range"
  },
  {
    "Region": "Central",
    "Store": "34921",
    "Brand": "7-Eleven",
    "Address": "2350 Hancock Expressway",
    "City": "Colorado Springs",
    "State": "CO",
    "ZipCode": "80910",
    "Division": "Front Range South"
  },
  {
    "Region": "Central",
    "Store": "37198",
    "Brand": "7-Eleven",
    "Address": "2093 South Cathay Way",
    "City": "Aurora",
    "State": "CO",
    "ZipCode": "80013",
    "Division": "Front Range"
  },
  {
    "Region": "Central",
    "Store": "18981",
    "Brand": "7-Eleven",
    "Address": "3501 East Grant Road",
    "City": "Tucson",
    "State": "AZ",
    "ZipCode": "85716",
    "Division": "Desert Southwest"
  },
  {
    "Region": "Central",
    "Store": "26085",
    "Brand": "7-Eleven",
    "Address": "1850 West Glendale Avenue",
    "City": "Phoenix",
    "State": "AZ",
    "ZipCode": "85021",
    "Division": "Desert Southwest Metro"
  },
  {
    "Region": "Central",
    "Store": "26411",
    "Brand": "7-Eleven",
    "Address": "8410 East McDonald Drive",
    "City": "Scottsdale",
    "State": "AZ",
    "ZipCode": "85250",
    "Division": "Desert Southwest Metro"
  },
  {
    "Region": "Central",
    "Store": "35754",
    "Brand": "7-Eleven",
    "Address": "11960 South Strang Line Road",
    "City": "Olathe",
    "State": "KS",
    "ZipCode": "66062",
    "Division": "Heartland Metro"
  },
  {
    "Region": "Central",
    "Store": "39274",
    "Brand": "7-Eleven",
    "Address": "495 Sheridan Blvd",
    "City": "Lakewood",
    "State": "CO",
    "ZipCode": "80226",
    "Division": "Front Range"
  },
  {
    "Region": "Central",
    "Store": "34462",
    "Brand": "7-Eleven",
    "Address": "3718 39th Avenue Drive",
    "City": "Moline",
    "State": "IL",
    "ZipCode": "61265",
    "Division": "Upper Midwest Plains"
  },
  {
    "Region": "Central",
    "Store": "26749",
    "Brand": "7-Eleven",
    "Address": "496 North University Avenue",
    "City": "Provo",
    "State": "UT",
    "ZipCode": "84601",
    "Division": "Mountain West Urban"
  },
  {
    "Region": "Central",
    "Store": "32265",
    "Brand": "7-Eleven",
    "Address": "485 West Warner Road",
    "City": "Tempe",
    "State": "AZ",
    "ZipCode": "85284",
    "Division": "Desert Southwest Metro"
  },
  {
    "Region": "Central",
    "Store": "26620",
    "Brand": "7-Eleven",
    "Address": "411 South Gilbert Road",
    "City": "Mesa",
    "State": "AZ",
    "ZipCode": "85204",
    "Division": "Desert Southwest Metro"
  },
  {
    "Region": "Central",
    "Store": "38083",
    "Brand": "7-Eleven",
    "Address": "7382 Federal Boulevard",
    "City": "Westminster",
    "State": "CO",
    "ZipCode": "80030",
    "Division": "Front Range"
  },
  {
    "Region": "North",
    "Store": "36131",
    "Brand": "7-Eleven",
    "Address": "10 West Prospect Avenue",
    "City": "Pittsburgh",
    "State": "PA",
    "ZipCode": "15205",
    "Division": "Appalachian Core"
  },
  {
    "Region": "North",
    "Store": "35933",
    "Brand": "7-Eleven",
    "Address": "1300 Bigley Avenue",
    "City": "Charleston",
    "State": "WV",
    "ZipCode": "25302",
    "Division": "Central Appalachia"
  },
  {
    "Region": "North",
    "Store": "17313",
    "Brand": "7-Eleven",
    "Address": "2910 John R Road",
    "City": "Troy",
    "State": "MI",
    "ZipCode": "48083",
    "Division": "Great Lakes Metro"
  },
  {
    "Region": "North",
    "Store": "36661",
    "Brand": "7-Eleven",
    "Address": "139 Cadillac Square",
    "City": "Detroit",
    "State": "MI",
    "ZipCode": "48226",
    "Division": "Great Lakes Metro"
  },
  {
    "Region": "North",
    "Store": "21439",
    "Brand": "7-Eleven",
    "Address": "2802 Walnut Street",
    "City": "Harrisburg",
    "State": "PA",
    "ZipCode": "17103",
    "Division": "Mid-Atlantic Inland"
  },
  {
    "Region": "North",
    "Store": "40232",
    "Brand": "7-Eleven",
    "Address": "366 East Jefferson Street",
    "City": "Butler",
    "State": "PA",
    "ZipCode": "16001",
    "Division": "Pennsylvania Corridor"
  },
  {
    "Region": "North",
    "Store": "34931",
    "Brand": "7-Eleven",
    "Address": "704 South Main Street",
    "City": "Ann Arbor",
    "State": "MI",
    "ZipCode": "48104",
    "Division": "Great Lakes Metro"
  },
  {
    "Region": "North",
    "Store": "19775",
    "Brand": "7-Eleven",
    "Address": "4505 Lewis Avenue",
    "City": "Toledo",
    "State": "OH",
    "ZipCode": "43612",
    "Division": "Ohio Valley"
  },
  {
    "Region": "North",
    "Store": "36238",
    "Brand": "7-Eleven",
    "Address": "1614 Merriman Road",
    "City": "Akron",
    "State": "OH",
    "ZipCode": "44313",
    "Division": "Ohio Valley"
  },
  {
    "Region": "North",
    "Store": "25704",
    "Brand": "7-Eleven",
    "Address": "101 E Broad St",
    "City": "Bethlehem",
    "State": "PA",
    "ZipCode": "18018",
    "Division": "Mid-Atlantic Inland"
  },
  {
    "Region": "North",
    "Store": "10911",
    "Brand": "7-Eleven",
    "Address": "325 Kellam Rd",
    "City": "Virginia Beach",
    "State": "VA",
    "ZipCode": "23462",
    "Division": "Atlantic Coastal South"
  },
  {
    "Region": "North",
    "Store": "34687",
    "Brand": "7-Eleven",
    "Address": "1401 Asbury Avenue",
    "City": "Asbury Park",
    "State": "NJ",
    "ZipCode": "07712",
    "Division": "Jersey Shore"
  },
  {
    "Region": "North",
    "Store": "10653",
    "Brand": "7-Eleven",
    "Address": "701 Van Buren Street",
    "City": "Herndon",
    "State": "VA",
    "ZipCode": "20170",
    "Division": "Northern Virginia Metro"
  },
  {
    "Region": "North",
    "Store": "23658",
    "Brand": "7-Eleven",
    "Address": "2759 North Harlem Avenue",
    "City": "Chicago",
    "State": "IL",
    "ZipCode": "60707",
    "Division": "Chicagoland Metro"
  },
  {
    "Region": "North",
    "Store": "26245",
    "Brand": "7-Eleven",
    "Address": "3301 West Cary Street",
    "City": "Richmond",
    "State": "VA",
    "ZipCode": "23221",
    "Division": "Mid-Atlantic Capital"
  },
  {
    "Region": "North",
    "Store": "23698",
    "Brand": "7-Eleven",
    "Address": "6401 Reisterstown Road",
    "City": "Baltimore",
    "State": "MD",
    "ZipCode": "21215",
    "Division": "Baltimore Metro"
  },
  {
    "Region": "North",
    "Store": "36876",
    "Brand": "7-Eleven",
    "Address": "654 North Dupont Highway",
    "City": "Dover",
    "State": "DE",
    "ZipCode": "19901",
    "Division": "Delaware Valley"
  },
  {
    "Region": "North",
    "Store": "40122",
    "Brand": "7-Eleven",
    "Address": "520 Jfk Memorial Hwy",
    "City": "Newark",
    "State": "DE",
    "ZipCode": "19702",
    "Division": "Delaware Valley"
  },
  {
    "Region": "North",
    "Store": "40074",
    "Brand": "7-Eleven",
    "Address": "8261 Stenton Avenue",
    "City": "Philadelphia",
    "State": "PA",
    "ZipCode": "19150",
    "Division": "Philadelphia Metro"
  },
  {
    "Region": "North",
    "Store": "35278",
    "Brand": "7-Eleven",
    "Address": "7401 Georgia Avenue Northwest",
    "City": "Washington",
    "State": "DC",
    "ZipCode": "20012",
    "Division": "National Capital"
  },
  {
    "Region": "Northeast",
    "Store": "35308",
    "Brand": "7-Eleven",
    "Address": "351 Bowery",
    "City": "New York",
    "State": "NY",
    "ZipCode": "10003",
    "Division": "NYC Core"
  },
  {
    "Region": "Northeast",
    "Store": "21826",
    "Brand": "7-Eleven",
    "Address": "Lefferts Boulevard",
    "City": "Kew Gardens",
    "State": "NY",
    "ZipCode": "11415",
    "Division": "NYC Outer Boroughs"
  },
  {
    "Region": "Northeast",
    "Store": "11181",
    "Brand": "7-Eleven",
    "Address": "4350 Merrick Road",
    "City": "Massapequa",
    "State": "NY",
    "ZipCode": "11758",
    "Division": "Long Island"
  },
  {
    "Region": "Northeast",
    "Store": "40431",
    "Brand": "7-Eleven",
    "Address": "902 Loudon Road",
    "City": "Latham",
    "State": "NY",
    "ZipCode": "12110",
    "Division": "Upstate New York"
  },
  {
    "Region": "Northeast",
    "Store": "32460",
    "Brand": "7-Eleven",
    "Address": "117 Jersey St # 121",
    "City": "Boston",
    "State": "MA",
    "ZipCode": "02215",
    "Division": "Boston Metro"
  },
  {
    "Region": "Northeast",
    "Store": "41546",
    "Brand": "7-Eleven",
    "Address": "106 Federal Road",
    "City": "Danbury",
    "State": "CT",
    "ZipCode": "06810",
    "Division": "Connecticut Corridor"
  },
  {
    "Region": "Northeast",
    "Store": "24433",
    "Brand": "7-Eleven",
    "Address": "361 Amherst Street",
    "City": "Nashua",
    "State": "NH",
    "ZipCode": "03063",
    "Division": "Northern New England"
  },
  {
    "Region": "Northeast",
    "Store": "32531",
    "Brand": "7-Eleven",
    "Address": "704 Congress Street",
    "City": "Portland",
    "State": "ME",
    "ZipCode": "04102",
    "Division": "Northern New England"
  },
  {
    "Region": "Northeast",
    "Store": "33426",
    "Brand": "7-Eleven",
    "Address": "65 Manton Avenue",
    "City": "Providence",
    "State": "RI",
    "ZipCode": "02909",
    "Division": "Southern New England"
  },
  {
    "Region": "Northeast",
    "Store": "39818",
    "Brand": "7-Eleven",
    "Address": "88 Essex St",
    "City": "Rochelle Park",
    "State": "NJ",
    "ZipCode": "07662",
    "Division": "North Jersey Metro"
  },
  {
    "Region": "Northeast",
    "Store": "32467",
    "Brand": "7-Eleven",
    "Address": "2002 Beacon St",
    "City": "Brighton",
    "State": "MA",
    "ZipCode": "02135",
    "Division": "Boston Metro"
  },
  {
    "Region": "Northeast",
    "Store": "32511",
    "Brand": "7-Eleven",
    "Address": "211 Main Street",
    "City": "Bondville",
    "State": "VT",
    "ZipCode": "05340",
    "Division": "Rural New England"
  },
  {
    "Region": "Northeast",
    "Store": "40271",
    "Brand": "7-Eleven",
    "Address": "634 George Washington Highway",
    "City": "Lincoln",
    "State": "RI",
    "ZipCode": "02865",
    "Division": "Southern New England"
  },
  {
    "Region": "Northeast",
    "Store": "32536",
    "Brand": "7-Eleven",
    "Address": "489 Main St",
    "City": "Springvale",
    "State": "ME",
    "ZipCode": "04083",
    "Division": "Northern New England"
  },
  {
    "Region": "Northeast",
    "Store": "35180",
    "Brand": "7-Eleven",
    "Address": "1504 Pine Avenue",
    "City": "Niagara Falls",
    "State": "NY",
    "ZipCode": "14301",
    "Division": "Upstate New York"
  },
  {
    "Region": "Northeast",
    "Store": "35193",
    "Brand": "7-Eleven",
    "Address": "4424 Lake Avenue",
    "City": "Rochester",
    "State": "NY",
    "ZipCode": "14612",
    "Division": "Upstate New York"
  },
  {
    "Region": "Northeast",
    "Store": "26366",
    "Brand": "7-Eleven",
    "Address": "290 South Summit Avenue",
    "City": "Hackensack",
    "State": "NJ",
    "ZipCode": "07601",
    "Division": "North Jersey Metro"
  },
  {
    "Region": "Northeast",
    "Store": "32957",
    "Brand": "7-Eleven",
    "Address": "2120 Park Street",
    "City": "Hartford",
    "State": "CT",
    "ZipCode": "06106",
    "Division": "Connecticut Corridor"
  },
  {
    "Region": "Northeast",
    "Store": "37393",
    "Brand": "7-Eleven",
    "Address": "1099 William S Canning Boulevard",
    "City": "Fall River",
    "State": "MA",
    "ZipCode": "02721",
    "Division": "Southern New England"
  },
  {
    "Region": "Northeast",
    "Store": "37365",
    "Brand": "7-Eleven",
    "Address": "530 Central Avenue",
    "City": "Dover",
    "State": "NH",
    "ZipCode": "03820",
    "Division": "Northern New England"
  },
  {
    "Region": "South",
    "Store": "25420",
    "Brand": "7-Eleven",
    "Address": "1500 W State Road 84",
    "City": "Fort Lauderdale",
    "State": "FL",
    "ZipCode": "33315",
    "Division": "South Florida"
  },
  {
    "Region": "South",
    "Store": "30030",
    "Brand": "7-Eleven",
    "Address": "9695 Southwest 88th Street",
    "City": "Miami",
    "State": "FL",
    "ZipCode": "33176",
    "Division": "South Florida"
  },
  {
    "Region": "South",
    "Store": "41922",
    "Brand": "7-Eleven",
    "Address": "11530 Pearland Parkway",
    "City": "Houston",
    "State": "TX",
    "ZipCode": "77089",
    "Division": "Texas Gulf Coast"
  },
  {
    "Region": "South",
    "Store": "35531",
    "Brand": "7-Eleven",
    "Address": "408 North Hampton Road",
    "City": "Dallas",
    "State": "TX",
    "ZipCode": "75208",
    "Division": "North Texas Metro"
  },
  {
    "Region": "South",
    "Store": "10249",
    "Brand": "7-Eleven",
    "Address": "6205 Gulf Boulevard",
    "City": "St Petersburg Beach",
    "State": "FL",
    "ZipCode": "33706",
    "Division": "Florida Gulf Coast"
  },
  {
    "Region": "South",
    "Store": "36999",
    "Brand": "7-Eleven",
    "Address": "823 Congress Avenue",
    "City": "Austin",
    "State": "TX",
    "ZipCode": "78701",
    "Division": "Texas Capital"
  },
  {
    "Region": "South",
    "Store": "35585",
    "Brand": "7-Eleven",
    "Address": "4401 Park Road",
    "City": "Charlotte",
    "State": "NC",
    "ZipCode": "28209",
    "Division": "Carolinas Metro"
  },
  {
    "Region": "South",
    "Store": "41415",
    "Brand": "7-Eleven",
    "Address": "2928 South Meridian Avenue",
    "City": "Oklahoma City",
    "State": "OK",
    "ZipCode": "73108",
    "Division": "Southern Plains"
  },
  {
    "Region": "South",
    "Store": "42019",
    "Brand": "7-Eleven",
    "Address": "12121 Northwest Expressway",
    "City": "Yukon",
    "State": "OK",
    "ZipCode": "73099",
    "Division": "Southern Plains"
  },
  {
    "Region": "South",
    "Store": "39128",
    "Brand": "7-Eleven",
    "Address": "4301 Sunset Boulevard",
    "City": "Lexington",
    "State": "SC",
    "ZipCode": "29072",
    "Division": "Carolina Midlands"
  },
  {
    "Region": "South",
    "Store": "41073",
    "Brand": "7-Eleven",
    "Address": "810 South Cumberland Street",
    "City": "Lebanon",
    "State": "TN",
    "ZipCode": "37087",
    "Division": "Tennessee Valley"
  },
  {
    "Region": "South",
    "Store": "41070",
    "Brand": "7-Eleven",
    "Address": "7070 US-70 S, TN-1",
    "City": "Nashville",
    "State": "TN",
    "ZipCode": "37221",
    "Division": "Tennessee Valley"
  },
  {
    "Region": "South",
    "Store": "41349",
    "Brand": "7-Eleven",
    "Address": "1312 Springsteen Road",
    "City": "Rock Hill",
    "State": "SC",
    "ZipCode": "29730",
    "Division": "Carolina Piedmont"
  },
  {
    "Region": "South",
    "Store": "40579",
    "Brand": "7-Eleven",
    "Address": "1200 TX-80, TX-142",
    "City": "San Marcos",
    "State": "TX",
    "ZipCode": "78666",
    "Division": "Texas Hill Country"
  },
  {
    "Region": "South",
    "Store": "25173",
    "Brand": "7-Eleven",
    "Address": "11775 131st Street North",
    "City": "Largo",
    "State": "FL",
    "ZipCode": "33774",
    "Division": "Florida Gulf Coast"
  },
  {
    "Region": "South",
    "Store": "27216",
    "Brand": "7-Eleven",
    "Address": "6845 North 22nd Street",
    "City": "Tampa",
    "State": "FL",
    "ZipCode": "33610",
    "Division": "Florida Gulf Coast"
  },
  {
    "Region": "South",
    "Store": "35596",
    "Brand": "7-Eleven",
    "Address": "304 Unionville Indian Trail Road",
    "City": "Indian Trail",
    "State": "NC",
    "ZipCode": "28079",
    "Division": "Carolinas Metro"
  },
  {
    "Region": "South",
    "Store": "36375",
    "Brand": "7-Eleven",
    "Address": "3700 Interstate 30",
    "City": "Mesquite",
    "State": "TX",
    "ZipCode": "75150",
    "Division": "North Texas Metro"
  },
  {
    "Region": "South",
    "Store": "41116",
    "Brand": "7-Eleven",
    "Address": "7303 Fairmont Parkway",
    "City": "Pasadena",
    "State": "TX",
    "ZipCode": "77505",
    "Division": "Texas Gulf Coast"
  },
  {
    "Region": "South",
    "Store": "36624",
    "Brand": "7-Eleven",
    "Address": "12011 San Pedro Avenue",
    "City": "San Antonio",
    "State": "TX",
    "ZipCode": "78216",
    "Division": "South Texas"
  },
  {
    "Region": "West",
    "Store": "34653",
    "Brand": "7-Eleven",
    "Address": "706 Pacific Coast Highway",
    "City": "Huntington Beach",
    "State": "CA",
    "ZipCode": "92648",
    "Division": "Southern California Coast"
  },
  {
    "Region": "West",
    "Store": "35884",
    "Brand": "7-Eleven",
    "Address": "1548 Adams Avenue",
    "City": "Costa Mesa",
    "State": "CA",
    "ZipCode": "92626",
    "Division": "Southern California Coast"
  },
  {
    "Region": "West",
    "Store": "34637",
    "Brand": "7-Eleven",
    "Address": "150 West Vista Chino",
    "City": "Palm Springs",
    "State": "CA",
    "ZipCode": "92262",
    "Division": "Southern California Desert"
  },
  {
    "Region": "West",
    "Store": "36435",
    "Brand": "7-Eleven",
    "Address": "470 North Chestnut Avenue",
    "City": "Fresno",
    "State": "CA",
    "ZipCode": "93702",
    "Division": "Central Valley"
  },
  {
    "Region": "West",
    "Store": "29795",
    "Brand": "7-Eleven",
    "Address": "2429 Mission Street",
    "City": "Santa Cruz",
    "State": "CA",
    "ZipCode": "95060",
    "Division": "Northern California Coast"
  },
  {
    "Region": "West",
    "Store": "20643",
    "Brand": "7-Eleven",
    "Address": "2000 Ocean Avenue",
    "City": "San Francisco",
    "State": "CA",
    "ZipCode": "94127",
    "Division": "Bay Area"
  },
  {
    "Region": "West",
    "Store": "39064",
    "Brand": "7-Eleven",
    "Address": "3111 West Temple Avenue",
    "City": "Pomona",
    "State": "CA",
    "ZipCode": "91768",
    "Division": "Inland Empire"
  },
  {
    "Region": "West",
    "Store": "38456",
    "Brand": "7-Eleven",
    "Address": "1360 South Figueroa Street",
    "City": "Los Angeles",
    "State": "CA",
    "ZipCode": "90015",
    "Division": "Los Angeles Core"
  },
  {
    "Region": "West",
    "Store": "34235",
    "Brand": "7-Eleven",
    "Address": "2387 Midway Drive",
    "City": "San Diego",
    "State": "CA",
    "ZipCode": "92110",
    "Division": "San Diego Metro"
  },
  {
    "Region": "West",
    "Store": "38749",
    "Brand": "7-Eleven",
    "Address": "8810 Lindell Road",
    "City": "Las Vegas",
    "State": "NV",
    "ZipCode": "89139",
    "Division": "Nevada Desert"
  },
  {
    "Region": "West",
    "Store": "29209",
    "Brand": "7-Eleven",
    "Address": "9710 Southeast Foster Road",
    "City": "Portland",
    "State": "OR",
    "ZipCode": "97266",
    "Division": "Pacific Northwest"
  },
  {
    "Region": "West",
    "Store": "38760",
    "Brand": "7-Eleven",
    "Address": "1025 Boulder City Parkway",
    "City": "Boulder City",
    "State": "NV",
    "ZipCode": "89005",
    "Division": "Nevada Desert"
  },
  {
    "Region": "West",
    "Store": "26363",
    "Brand": "7-Eleven",
    "Address": "590 E Broadway",
    "City": "Eugene",
    "State": "OR",
    "ZipCode": "97401",
    "Division": "Pacific Northwest"
  },
  {
    "Region": "West",
    "Store": "24279",
    "Brand": "7-Eleven",
    "Address": "12908 Ne Highway 99",
    "City": "Vancouver",
    "State": "WA",
    "ZipCode": "98686",
    "Division": "Pacific Northwest"
  },
  {
    "Region": "West",
    "Store": "35274",
    "Brand": "7-Eleven",
    "Address": "3922 Portland Avenue East",
    "City": "Tacoma",
    "State": "WA",
    "ZipCode": "98404",
    "Division": "Puget Sound"
  },
  {
    "Region": "West",
    "Store": "14392",
    "Brand": "7-Eleven",
    "Address": "9 Nickerson Street",
    "City": "Seattle",
    "State": "WA",
    "ZipCode": "98109",
    "Division": "Puget Sound"
  },
  {
    "Region": "West",
    "Store": "41553",
    "Brand": "7-Eleven",
    "Address": "1110 South Rock Boulevard",
    "City": "Reno",
    "State": "NV",
    "ZipCode": "89502",
    "Division": "Nevada High Desert"
  },
  {
    "Region": "West",
    "Store": "18386",
    "Brand": "7-Eleven",
    "Address": "901 Tahoe Blvd",
    "City": "Incline Village",
    "State": "NV",
    "ZipCode": "89451",
    "Division": "Lake Tahoe"
  },
  {
    "Region": "West",
    "Store": "41230",
    "Brand": "7-Eleven",
    "Address": "4316 Town Center Blvd",
    "City": "El Dorado Hills",
    "State": "CA",
    "ZipCode": "95762",
    "Division": "Northern California Foothills"
  },
  {
    "Region": "West",
    "Store": "42175",
    "Brand": "7-Eleven",
    "Address": "1911 Cosumnes River Boulevard",
    "City": "Sacramento",
    "State": "CA",
    "ZipCode": "95832",
    "Division": "Sacramento Valley"
  }
]
export default Datamap